import { sendEventToSegment } from 'redux/modules/analytics';

const GLOBAL_NAMESPACE = 'ME__fleet_process';

const buildFunctions = (eventList) => {
  return Object.keys(eventList).reduce((acc, eventKey) => {
    const eventName = eventList[eventKey];
    const functionTrigger = (params = {}) => {
      sendEventToSegment(eventName, params);
    };
    return {
      ...acc,
      [eventKey]: functionTrigger,
    };
  }, {});
};

const fleetTabEvents = {
  APPLY_FILTER: `${GLOBAL_NAMESPACE}__fleet_tab__apply_filter`,
};

const driverReviewEvents = {
  OPEN_JOB_DETAIL: `${GLOBAL_NAMESPACE}__driver_review__open_detail`,
  CALL_SHIPPER: `${GLOBAL_NAMESPACE}__driver_review__call_shipper`,
  CALL_CARRIER: `${GLOBAL_NAMESPACE}__driver_review__call_carrier`,
  UNASSIGN: `${GLOBAL_NAMESPACE}__driver_review__click_unassign`,
};

const gatekeepingEvents = {
  REVIEWED_AS_AUTO: `${GLOBAL_NAMESPACE}__gatekeeping__reviewed_as_auto`,
  REVIEWED_AS_MANUAL: `${GLOBAL_NAMESPACE}__gatekeeping__reviewed_as_manual`,
  EDIT_ORDER_CLICK: `${GLOBAL_NAMESPACE}__gatekeeping__edit_order_click`,
  COPY_ID_CLICK: `${GLOBAL_NAMESPACE}__gatekeeping__copy_id_click`,
  VIEW_ROUTE_ON_GOOGLE_MAPS_CLICK: `${GLOBAL_NAMESPACE}__gatekeeping__view_route_on_google_maps_click`,
};

const dispatchingEvents = {
  ADD_TO_ROUTING: `${GLOBAL_NAMESPACE}__dispatching__add_to_routing`,
  ASSIGN_TO_DRIVER_CLICK: `${GLOBAL_NAMESPACE}__dispatching__assign_to_driver_click`,
  MOVE_TO_AUTO: `${GLOBAL_NAMESPACE}__dispatching__move_to_auto`,
  MOVE_TO_MANUAL: `${GLOBAL_NAMESPACE}__dispatching__move_to_manual`,
  ROUTE_SUGGESTION_CLICK: `${GLOBAL_NAMESPACE}__dispatching__route_suggestion_click`,
  DISTANCE_CLICK: `${GLOBAL_NAMESPACE}__dispatching__distance_click`,
  CHECK_CAPACITY: `${GLOBAL_NAMESPACE}__dispatching__check_capacity`,
  MAKE_ASSIGNMENT: `${GLOBAL_NAMESPACE}__dispatching__make_assignment`,
  CREATE_ROUTE: `${GLOBAL_NAMESPACE}__dispatching__create_route`,
  ASSIGN_ROUTE: `${GLOBAL_NAMESPACE}__dispatching__assign_route`,
  COST_CHANGE: `${GLOBAL_NAMESPACE}__dispatching__cost_change`,
  OPEN_BIDDING: `${GLOBAL_NAMESPACE}__dispatching__open_bidding`,
  EDIT_ORDER_CLICK: `${GLOBAL_NAMESPACE}__dispatching__edit_order`,
};

const biddingEvents = {
  CALL_DRIVER: `${GLOBAL_NAMESPACE}__bidding__call_driver`,
};

const DRIVER_REVIEW = buildFunctions(driverReviewEvents);
const GATEKEEPING = buildFunctions(gatekeepingEvents);
const DISPATCHING = buildFunctions(dispatchingEvents);
const FLEET_TAB = buildFunctions(fleetTabEvents);
const BIDDING = buildFunctions(biddingEvents);

export { DRIVER_REVIEW, GATEKEEPING, FLEET_TAB, DISPATCHING, BIDDING };
